import Flag from 'LuxKit/Flag'
import type { ComponentProps } from 'react'
import React from 'react'
import { useIntl } from 'react-intl'
import type { PhonePrefixCountry } from './PhoneInput'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import styled from 'styled-components'

const HidableListItem = styled(ClickableListItem)`
  &[hidden] {
    display: none;
  }

`

interface Props extends Pick<ComponentProps<typeof ClickableListItem>, 'size'> {
  onSelect: (country: PhonePrefixCountry) => void
  selected?: boolean
  country: PhonePrefixCountry
  hidden?: boolean
}

function PhonePrefixItem(props: Props) {
  const { country, selected, onSelect, hidden, size = 'small' } = props
  const intl = useIntl()

  const onClick = () => {
    onSelect(country)
  }

  return <HidableListItem
    size={size}
    title={intl.formatMessage({
      id: '-j5MJwoNiywI5k_ZY6QK',
      defaultMessage: '{countryName} (+{dialCode})',
      description: 'Phone prefix list item showing country name and international dial code',
    }, { countryName: country.name, dialCode: country.dialCode })}
    startIcon={<Flag countryCode={country.iso2.toUpperCase()} />}
    selected={selected}
    onClick={onClick}
    hidden={hidden}
  />
}

export default React.memo(PhonePrefixItem)
